import CloseIcon from "@mui/icons-material/Close";
import SyncAltIcon from "@mui/icons-material/SyncAlt";
import ReplayIcon from "@mui/icons-material/Replay";
import TuneIcon from "@mui/icons-material/Tune";
import IconButton from "@mui/material/IconButton";
import Grid from "@mui/material/Grid";
import Badge from "@mui/material/Badge";
import { useTheme } from "@mui/material/styles";
import { useState } from "react";
import Button from "components/ui/atoms/Button";
import Dialog from "components/ui/atoms/Dialog";
import Highlight from "components/ui/atoms/Highlight";
import SearchBox from "components/ui/atoms/SearchBox";
import { Tooltip, Typography } from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import { IconOrLongButton } from "../atoms/Button";

const FilterAndSort = ({
  FilterForm,
  SortForm,
  state,
  setState,
  count,
  refetch,
}) => {
  const theme = useTheme();
  const [openFilters, setOpenFilters] = useState(false);
  const [openSorts, setOpenSorts] = useState(false);

  const handleOpenFilters = () => {
    setOpenFilters(true);
  };
  const handleCloseFilters = () => {
    setOpenFilters(false);
  };
  const handleClear = () => {
    setState({
      ...state,
      sort: undefined,
      filter: undefined,
      search: "",
      offset: undefined,
    });
  };
  const handleOpenSorts = () => {
    setOpenSorts(true);
  };
  const handleCloseSorts = () => {
    setOpenSorts(false);
  };

  const updateFilter = (values) => {
    setState({
      ...state,
      filter: values,
      offset: 0,
    });
    handleCloseFilters();
  };

  const updateSort = async (values) => {
    setState({
      ...state,
      sort: values,
      offset: 0,
    });
    handleCloseSorts();
  };

  const updateSearch = async (search) => {
    setState({
      ...state,
      search: search,
    });
  };

  const hasFilter = () => {
    if (!state.filter) return false;
    for (var key in state.filter) {
      if (Array.isArray(state.filter[key]) && state.filter[key].length == 0)
        continue;
      if (state.filter[key]) return true;
    }
    return false;
  };

  const hasSort = () => {
    if (!state.sort) return false;
    for (var key in state.sort) {
      if (Array.isArray(state.sort[key]) && state.sort[key].length == 0)
        continue;
      if (state.sort[key]) return true;
    }
    return false;
  };

  return (
    <>
      {FilterForm && (
        <Dialog
          title={
            <Highlight color={theme.palette_custom.yellow}>Filters</Highlight>
          }
          content={
            <FilterForm initialValues={state.filter} onSubmit={updateFilter} />
          }
          open={openFilters}
          handleClose={() => {
            setOpenFilters(false);
          }}
        />
      )}
      {SortForm && (
        <Dialog
          title={
            <Highlight color={theme.palette_custom.yellow}>Sorts</Highlight>
          }
          content={
            <SortForm initialValues={state.sort} onSubmit={updateSort} />
          }
          open={openSorts}
          handleClose={handleCloseSorts}
        />
      )}
      <Grid container spacing={1} wrap="nowrap" sx={{ flexGrow: 1 }}>
        <Grid sx={{ flexGrow: 1 }}>
          <SearchBox
            placeholder="Search ..."
            handleOnChange={updateSearch}
            query={state.search || ""}
          />
        </Grid>
        {FilterForm && (
          <Grid>
            <Badge color="primary" variant={hasFilter() ? "dot" : ""}>
              <IconOrLongButton
                endIcon={<TuneIcon sx={{ scale: "0.8" }} />}
                onClick={handleOpenFilters}
              >
                Filters
              </IconOrLongButton>
            </Badge>
          </Grid>
        )}
        {SortForm && (
          <Grid>
            <Badge color="primary" variant={hasSort() ? "dot" : ""}>
              <IconOrLongButton
                endIcon={
                  <SyncAltIcon
                    sx={{ transform: "rotate(90deg)", scale: "0.7" }}
                  />
                }
                onClick={handleOpenSorts}
              >
                Sorts
              </IconOrLongButton>
            </Badge>
          </Grid>
        )}
        <Grid>
          <Button
            endIcon={<CloseIcon sx={{ scale: "0.8" }} />}
            onClick={handleClear}
            sx={{ display: { xs: "none", md: "inline-flex" } }}
            disabled={!(hasFilter() || hasSort() || state.search)}
          >
            Clear
          </Button>
          <IconButton
            onClick={handleClear}
            sx={{ display: { xs: "inline-flex", md: "none" } }}
          >
            <CloseIcon />
          </IconButton>
        </Grid>
      </Grid>
      <Grid container spacing={1} wrap="nowrap">
        <Grid sx={{ mr: "auto", display: "flex", alignItems: "center" }}>
          {count !== undefined ? (
            <>
              <Typography variant="body1">{count} results</Typography>
              <Tooltip title={<pre>{JSON.stringify(state, null, 4)}</pre>}>
                <InfoIcon sx={{ ml: 1, scale: "0.7", opacity: "0.7" }} />
              </Tooltip>
              {refetch && (
                <IconButton onClick={refetch}>
                  <ReplayIcon sx={{ scale: "0.7", opacity: "0.7" }} />
                </IconButton>
              )}
            </>
          ) : (
            <Typography variant="body1">&nbsp;</Typography>
          )}
        </Grid>
      </Grid>
    </>
  );
};

export default FilterAndSort;
